module.exports = __webpack_public_path__ + "static/robot-d31d5502446152bec90a4aedfff04951.png";